/**
 * Proveedores de correo conocidos, con sus servidores IMAP/SMTP.
 *
 * Una sola lista para el alta Y para la reconexión: cuando el correo de la
 * empresa se movió de Hostinger a Google Workspace, el modal de reconectar solo
 * dejaba cambiar el servidor IMAP a mano y no tocaba el SMTP, así que la cuenta
 * volvía a leer pero no podía enviar. Elegir «Gmail» tiene que rellenar los dos.
 */
/**
 * `smtpUseTls` significa «exige TLS»: el envío lo interpreta como STARTTLS
 * obligatorio en el 587 y TLS implícito en el 465 (ver routes/emails-send.ts).
 * Va a true en todos los proveedores: ponerlo a false en el 587 era relajar el
 * cifrado del envío, no elegir un puerto.
 */
export interface EmailPreset {
  key: 'gmail' | 'outlook' | 'icloud' | 'custom'
  labelKey: string
  imapHost: string
  imapPort: number
  imapUseTls: boolean
  smtpHost: string
  smtpPort: number
  smtpUseTls: boolean
  hintKey?: string
}

export const EMAIL_PRESETS: EmailPreset[] = [
  {
    key: 'gmail',
    labelKey: 'newAccountModal.presets.gmail.label',
    imapHost: 'imap.gmail.com',
    imapPort: 993,
    imapUseTls: true,
    smtpHost: 'smtp.gmail.com',
    smtpPort: 465,
    smtpUseTls: true,
    hintKey: 'newAccountModal.presets.gmail.hint',
  },
  {
    key: 'outlook',
    labelKey: 'newAccountModal.presets.outlook.label',
    imapHost: 'outlook.office365.com',
    imapPort: 993,
    imapUseTls: true,
    smtpHost: 'smtp.office365.com',
    smtpPort: 587,
    smtpUseTls: true,
    hintKey: 'newAccountModal.presets.outlook.hint',
  },
  {
    key: 'icloud',
    labelKey: 'newAccountModal.presets.icloud.label',
    imapHost: 'imap.mail.me.com',
    imapPort: 993,
    imapUseTls: true,
    smtpHost: 'smtp.mail.me.com',
    smtpPort: 587,
    smtpUseTls: true,
    hintKey: 'newAccountModal.presets.icloud.hint',
  },
  {
    key: 'custom',
    labelKey: 'newAccountModal.presets.custom.label',
    imapHost: '',
    imapPort: 993,
    imapUseTls: true,
    smtpHost: '',
    smtpPort: 587,
    smtpUseTls: true,
  },
]

/** Preset cuyo servidor IMAP coincide con el de la cuenta; `custom` si ninguno. */
export function presetForHost(host: string | null | undefined): EmailPreset {
  const h = (host ?? '').trim().toLowerCase()
  return EMAIL_PRESETS.find((p) => p.imapHost && p.imapHost === h) ?? EMAIL_PRESETS[EMAIL_PRESETS.length - 1]!
}
